class SlideshowTabs extends HTMLElement {
  constructor() {
    super();

    this.CLASSES = {
      active: 'active',
      loading: 'loading',
    };

    this.SELECTORS = {
      slideshowThumbsMobile: '.js-slideshow-thumbs',
      slideshowCarouselMobile: '.js-slideshow-carousel',
      tabHeaderDesktop: '[data-tab-header-desktop]',
      tabHeaderMobile: '[data-tab-header-mobile]',
      tabPanel: '[data-tab-panel]',
      desktopTabHeaderContainer: '.js-desktop-tab-header-container',
    };

    this.tabs = [];
  }

  connectedCallback() {
    this.initTabs();
  }

  disconnectedCallback() {}

  attributeChangedCallback(name, oldValue, newValue) {}

  initTabs() {
    this.tabs = Array.from(this.querySelectorAll(this.SELECTORS.tabHeaderDesktop)).map((tab) => {
      const tabId = tab.dataset.tabId;
      const tabPanel = this.querySelector(`${this.SELECTORS.tabPanel}[data-tab-id="${tabId}"]`);

      return {
        tabId: tabId,
        tabPanel: tabPanel,
        tabHeaderDesktop: tab,
        tabHeaderMobile: this.querySelector(`${this.SELECTORS.tabHeaderMobile}[data-tab-id="${tabId}"]`),
      };
    });

    this.registerPanelEvents();
    this.registerSlideshowEvents();
    this.initCarousel();
    this.startSlideshow();
  }

  initCarousel() {
    const $this = this;

    this.swiperThumbs = new Swiper(this.querySelector(this.SELECTORS.slideshowThumbsMobile), {
      loop: true,
      slideToClickedSlide: true,
      slidesPerView: 2.5,
      allowTouchMove: true,
      spaceBetween: 10,
      centeredSlides: false,
    });

    this.swiperCarousel = new Swiper(this.querySelector(this.SELECTORS.slideshowCarouselMobile), {
      loop: true,
      slidesPerView: 1,
      effect: 'fade',
    });

    this.swiperCarousel.on('slideChange', function (e) {
      $this.openTab(this.slides[e.realIndex].dataset.tabId, false);
    });

    this.swiperThumbs.on('slideChange', function (e) {
      $this.swiperCarousel.slideTo(e.realIndex);
    });
  }

  startSlideshow() {
    const currentTab = this.activeTabPanel;
    const currentVideo = this.getVideo(currentTab);

    if (currentVideo) {
      currentVideo.play();
    } else {
      if (this.autoplay) {
        setTimeout(() => {
          this.goToNextTab();
        }, this.autoplayInterval);
      }
    }
  }

  registerPanelEvents() {
    this.tabs.forEach((tab) => {
      const currentVideo = this.getVideo(tab.tabPanel);

      if (currentVideo && this.autoplay) {
        currentVideo.addEventListener('ended', this.goToNextTab.bind(this));
      }
    });
  }

  destroyPanelEvents() {
    this.tabs.forEach((tab) => {
      const currentVideo = this.getVideo(tab.tabPanel);

      if (currentVideo) {
        currentVideo.pause();
        currentVideo.removeEventListener('ended', this.goToNextTab);
      }
    });
  }

  registerSlideshowEvents() {
    this.tabs.forEach((tab) => {
      tab.tabHeaderDesktop.addEventListener('click', (event) => this.handleTabDesktopClick(event, tab));
    });
  }

  handleTabDesktopClick(event, tab) {
    this.openTab(tab.tabId);
  }

  openTab(tabId, shouldUpdateMobileTabHeader = true) {
    const currentTab = this.tabs.find((tab) => tab.tabId === tabId);
    const tabVideo = this.getVideo(currentTab.tabPanel) || null;

    this.hideTabs(currentTab.tabPanel);
    this.updateTabHeaders(currentTab, shouldUpdateMobileTabHeader);
    currentTab.tabPanel.classList.add(this.CLASSES.active);

    if (tabVideo) {
      tabVideo.play();
    } else {
      if (this.autoplay) {
        setTimeout(() => {
          this.goToNextTab();
        }, this.autoplayInterval);
      }
    }
  }

  hideTabs(lastTabPanel) {
    this.tabs.forEach((tab) => {
      tab.tabHeaderDesktop.classList.remove(this.CLASSES.active);
      tab.tabHeaderDesktop.parentElement.classList.remove(this.CLASSES.active);

      tab.tabPanel.classList.remove(this.CLASSES.active);
      if (this.getVideo(tab.tabPanel)) {
        this.getVideo(tab.tabPanel).pause();
      }
    });

    this.destroyPanelEvents();
  }

  goToNextTab() {
    const currentTab = this.tabs.find((tab) => tab.tabId === this.activeTabHeader.dataset.tabId);
    const currentIndex = this.tabs.indexOf(currentTab);
    const nextIndex = (currentIndex + 1) % this.tabs.length;
    const nextTab = this.tabs[nextIndex];

    this.destroyPanelEvents();
    this.openTab(nextTab.tabId);
  }

  updateTabHeaders(currentTab, shouldUpdateMobileTabHeader = true) {
    const desktopTabHeaderContainer = document.querySelector(this.SELECTORS.desktopTabHeaderContainer);
    const tabHeader = currentTab.tabHeaderDesktop;
    const mobileTabTitle = document.querySelector('.js-mobile-tab-title');
    const mobileTabText = document.querySelector('.js-mobile-tab-text');
    const mobileTabContent = document.querySelector('.js-mobile-tab-content');
    mobileTabContent.classList.add(this.CLASSES.loading);

    if (shouldUpdateMobileTabHeader) {
      this.swiperCarousel.slideTo(currentTab.tabHeaderMobile.dataset.swiperSlideIndex);
    }

    currentTab.tabHeaderDesktop.classList.add(this.CLASSES.active);
    currentTab.tabHeaderDesktop.parentElement.classList.add(this.CLASSES.active);
    desktopTabHeaderContainer.style.minHeight = desktopTabHeaderContainer.offsetHeight + 'px';
    desktopTabHeaderContainer.classList.add(this.CLASSES.loading);

    desktopTabHeaderContainer.scrollTo({
      left: 0,
      behavior: 'smooth',
    });

    if (tabHeader.parentElement.querySelector('[data-tab-title]')) {
      setTimeout(() => {
        mobileTabTitle.textContent = tabHeader.parentElement.querySelector('[data-tab-title]').textContent;
        mobileTabText.textContent = tabHeader.parentElement.querySelector('[data-tab-text]').textContent;
        setTimeout(() => {
          mobileTabContent.classList.remove(this.CLASSES.loading);
          desktopTabHeaderContainer.classList.remove(this.CLASSES.loading);
          setTimeout(() => {
            desktopTabHeaderContainer.style.minHeight = 'auto';
          }, 500);
        }, 250);
      }, 250);
    }
  }

  getVideo(panel) {
    return panel.querySelector('[data-video-player]');
  }

  get tabHeaders() {
    return this.querySelectorAll(this.SELECTORS.tabHeaderDesktop);
  }

  get tabPanels() {
    return this.querySelectorAll(this.SELECTORS.tabPanel);
  }

  get activeTabHeader() {
    return this.querySelector(this.SELECTORS.tabHeaderDesktop + '.active');
  }

  get activeTabPanel() {
    return this.querySelector(this.SELECTORS.tabPanel + '.active');
  }

  get autoplayInterval() {
    return this.getAttribute('data-autoplay-interval') || 10000;
  }

  get autoplay() {
    return this.getAttribute('data-autoplay') === 'true' || false;
  }
}
customElements.define('slideshow-tabs', SlideshowTabs);
